import React, { useContext, memo } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { RightsContext } from 'providers/RightsContext';
import { TextField } from '@totalsoft/rocket-ui';

const OfferFinancialServicesHeaderComponentExtendedFields = ({ t, validationInfo, onHeaderPropertyChange, header, offerTypeId }) => {
  const { readOnlyFull, financialServicesWrite } = useContext(RightsContext);
  return (
    <Grid item xs={12} sm={3}>
      <TextField
        id={'offerFinancialServicesCard_agreedMileage'}
        fullWidth
        isNumeric
        value={header.agreedMileage || ''}
        inputProps={{ decimalScale: 0 }}
        onChange={onHeaderPropertyChange('agreedMileage', offerTypeId)}
        label={t('OfferEdit.FinancialServices.AgreedMileage')}
        error={validationInfo.header?.agreedMileage ? true : false}
        helperText={validationInfo.header?.agreedMileage}
        disabled={readOnlyFull || header.productKmReadOnly || !financialServicesWrite}
      />
    </Grid>
  );
};

OfferFinancialServicesHeaderComponentExtendedFields.propTypes = {
  t: PropTypes.func.isRequired,
  validationInfo: PropTypes.object.isRequired,
  wheelSizes: PropTypes.array,
  onHeaderPropertyChange: PropTypes.func.isRequired,
  header: PropTypes.object.isRequired,
  offerTypeId: PropTypes.number.isRequired
};

export default withTranslation()(memo(OfferFinancialServicesHeaderComponentExtendedFields));
